import React, { Component } from "react";
import Directory from "./directory";
//import Button from '@material-ui/core/Button';
import Styles from "./styles/drawerStyles";
class TopDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuData: [],
      open: props.open ? props.open : false
    };
  }

  componentDidMount() {
    const search = document.getElementById("search");
    search.tabIndex = "-1";
  }

  clearField(event) {
    event.target.placeholder = "";
  }

  handleClick(event) {
    window.location =
      "https://www.uvm.edu/a_to_z?" +
      event.target.firstChild.data.toLowerCase();
  }

  renderItems() {
    const mobileStyles = {
      width: "100%",
      position: "relative",
      float: "left",
      height: "auto"
    };
    const fullStylesAZ = {
      width: "50%",
      position: "absolute",
      top: 0,
      left: "50%",
      height: "220px"
    };
    const fullStylesSearch = {
      position: "absolute",
      top: 0,
      left: "20px",
      height: "220px"
    };
    let placementAz = "";
    if (window.innerWidth > 899) {
      placementAz = fullStylesAZ;
    } else {
      placementAz = mobileStyles;
    }

    let placementSearch = "";
    if (window.innerWidth > 899) {
      placementSearch = fullStylesSearch;
    } else {
      placementSearch = mobileStyles;
    }

    return (
      <div
        style={{
          height: window.innerWidth > 899 ? "220px" : "auto",
          backgroundColor: "#fff",
          display: "block",
          color: "#000",
          position: "relative"
        }}
      >
        <div
          id="gsearch"
          style={{
            boxSizing: "border-box",
            ...placementSearch,
            backgroundColor: "#fff",
            padding: "20px"
          }}
        >
          <div id="gcsepeople">
            <p style={{ fontWeight: "bold", fontSize: "24px" }}>
              Search Website{" "}
              <span style={{ fontSize: "16px", fontWeight: "400" }}>
                Enhanced by Google
              </span>
            </p>
            <form
              id="googleSeach"
              style={Styles.formStyle}
              method="get"
              title="Google Search Form"
              action="https://www.uvm.edu/search_results"
            >
              <div>
                <label htmlFor="googleSeach">
                  <input
                    tabIndex="-1"
                    style={Styles.inputStyle}
                    onFocus={this.clearField}
                    type="text"
                    id="q_as"
                    name="q_as"
                    title="Search this site"
                    alt="Google Site Search"
                    maxLength="256"
                    placeholder="What are you looking for?"
                  />
                  <button tabIndex="-1" style={Styles.buttonStyle}>
                    <svg width="13" height="13" viewBox="0 0 13 13">
                      <title>search</title>
                      <path d="m4.8495 7.8226c0.82666 0 1.5262-0.29146 2.0985-0.87438 0.57232-0.58292 0.86378-1.2877 0.87438-2.1144 0.010599-0.82666-0.28086-1.5262-0.87438-2.0985-0.59352-0.57232-1.293-0.86378-2.0985-0.87438-0.8055-0.010599-1.5103 0.28086-2.1144 0.87438-0.60414 0.59352-0.8956 1.293-0.87438 2.0985 0.021197 0.8055 0.31266 1.5103 0.87438 2.1144 0.56172 0.60414 1.2665 0.8956 2.1144 0.87438zm4.4695 0.2115 3.681 3.6819-1.259 1.284-3.6817-3.7 0.0019784-0.69479-0.090043-0.098846c-0.87973 0.76087-1.92 1.1413-3.1207 1.1413-1.3553 0-2.5025-0.46363-3.4417-1.3909s-1.4088-2.0686-1.4088-3.4239c0-1.3553 0.4696-2.4966 1.4088-3.4239 0.9392-0.92727 2.0864-1.3969 3.4417-1.4088 1.3553-0.011889 2.4906 0.45771 3.406 1.4088 0.9154 0.95107 1.379 2.0924 1.3909 3.4239 0 1.2126-0.38043 2.2588-1.1413 3.1385l0.098834 0.090049z" />
                    </svg>
                  </button>
                </label>
              </div>
            </form>
          </div>
          <p style={{ fontWeight: "bold", fontSize: "24px" }}>People Search</p>
          <form
            style={Styles.formStyle}
            method="get"
            title="People Search Form"
            action="https://www.uvm.edu/directory"
          >
            <label htmlFor="search">
              <Directory />
              <button tabIndex="-1" style={Styles.buttonStyle}>
                <svg width="13" height="13" viewBox="0 0 13 13">
                  <title>search</title>
                  <path d="m4.8495 7.8226c0.82666 0 1.5262-0.29146 2.0985-0.87438 0.57232-0.58292 0.86378-1.2877 0.87438-2.1144 0.010599-0.82666-0.28086-1.5262-0.87438-2.0985-0.59352-0.57232-1.293-0.86378-2.0985-0.87438-0.8055-0.010599-1.5103 0.28086-2.1144 0.87438-0.60414 0.59352-0.8956 1.293-0.87438 2.0985 0.021197 0.8055 0.31266 1.5103 0.87438 2.1144 0.56172 0.60414 1.2665 0.8956 2.1144 0.87438zm4.4695 0.2115 3.681 3.6819-1.259 1.284-3.6817-3.7 0.0019784-0.69479-0.090043-0.098846c-0.87973 0.76087-1.92 1.1413-3.1207 1.1413-1.3553 0-2.5025-0.46363-3.4417-1.3909s-1.4088-2.0686-1.4088-3.4239c0-1.3553 0.4696-2.4966 1.4088-3.4239 0.9392-0.92727 2.0864-1.3969 3.4417-1.4088 1.3553-0.011889 2.4906 0.45771 3.406 1.4088 0.9154 0.95107 1.379 2.0924 1.3909 3.4239 0 1.2126-0.38043 2.2588-1.1413 3.1385l0.098834 0.090049z" />
                </svg>
              </button>
            </label>
          </form>
        </div>

        <div
          id="az"
          style={{
            backgroundColor: "#fff",
            display: "block",
            padding: "20px",
            ...placementAz
          }}
        >
          <h2>A to Z</h2>
          <ul
            id="azlist"
            className="alpha"
            style={{
              height: "220px",
              listStyleType: "none",
              display: "table-row"
            }}
          >
            <li style={Styles.liStyle} id="A">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                A
              </button>
            </li>
            <li style={Styles.liStyle} id="B">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                B
              </button>
            </li>
            <li style={Styles.liStyle} id="C">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                C
              </button>
            </li>
            <li style={Styles.liStyle} id="D">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                D
              </button>
            </li>
            <li style={Styles.liStyle} id="E">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                E
              </button>
            </li>
            <li style={Styles.liStyle} id="F">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                F
              </button>
            </li>
            <li style={Styles.liStyle} id="G">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                G
              </button>
            </li>
            <li style={Styles.liStyle} id="H">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                H
              </button>
            </li>
            <li style={Styles.liStyle} id="I">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                I
              </button>
            </li>
            <li style={Styles.liStyle} id="J">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                J
              </button>
            </li>
            <li style={Styles.liStyle} id="K">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                K
              </button>
            </li>
            <li style={Styles.liStyle} id="L">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                L
              </button>
            </li>
            <li style={Styles.liStyle} id="M">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                M
              </button>
            </li>
            <li style={Styles.liStyle} id="N">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                N
              </button>
            </li>
            <li style={Styles.liStyle} id="O">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                O
              </button>
            </li>
            <li style={Styles.liStyle} id="P">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                P
              </button>
            </li>
            <li style={Styles.liStyle} id="Q">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                Q
              </button>
            </li>
            <li style={Styles.liStyle} id="R">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                R
              </button>
            </li>
            <li style={Styles.liStyle} id="S">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                S
              </button>
            </li>
            <li style={Styles.liStyle} id="T">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                T
              </button>
            </li>
            <li style={Styles.liStyle} id="U">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                U
              </button>
            </li>
            <li style={Styles.liStyle} id="V">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                V
              </button>
            </li>
            <li style={Styles.liStyle} id="W">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                W
              </button>
            </li>
            <li style={Styles.liStyle} id="X">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                X
              </button>
            </li>
            <li style={Styles.liStyle} id="Y">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                Y
              </button>
            </li>
            <li style={Styles.liStyle} id="Z">
              <button
                tabIndex="-1"
                style={Styles.aStyle}
                onClick={this.handleClick}
              >
                Z
              </button>
            </li>
          </ul>
        </div>
      </div>
    );
  }

  render() {
    const invisible = {
      position: "absolute",
      top: "-1500px",
      width: "100%",
      overflow: "hidden",
      zIndex: "999999",
      backgroundColor: "#fff",
      height: window.innerWidth > 899 ? "300px" : "auto"
    };

    const searchBox = {
      backgroundColor: "#fff",
      width: "100%",
      maxWidth: "1200px",
      marginLeft: "auto",
      marginRight: "auto",
      height: window.innerWidth > 899 ? "220px" : "auto",
      marginTop: "-20px"
    };

    return (
      <div className="menu" id="topDrawerMenu" style={invisible}>
        <div className="SearchBox" style={searchBox}>
          {this.renderItems()}
        </div>
      </div>
    );
  }
}

export default TopDrawer;
